import { useStore as getStore } from "../../utils/useStore.js";
import commentsFactory from "./commentsFactory.js";
const initialState = () => ({
  value: 0,
});
const [CommentsProvider, useComments, withComments] = getStore(
  commentsFactory,
  initialState,
  "Comment"
);
export const commentsInitState = initialState();
export { useComments, CommentsProvider, withComments };
export default CommentsProvider;
